import { publicConfig } from "@/PublicConfig";
import { getFastshotHeaderValues } from "@/utils/fastshot";

interface CreateFastshotOptions {
  payload: {};
}

export interface CreateFastshotResult {
  height: number;
  htmlTree: string;
  image: string;
  pdf: boolean;
  title: string;
  width: number;
}

export const createFastshot = async (options: CreateFastshotOptions): Promise<CreateFastshotResult> => {
  const url = new URL(publicConfig.screenshotWorkerEndpointURL);

  url.pathname = "/screenshot/fastshot";

  const response = await fetch(url, {
    body: JSON.stringify(options.payload),
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
  });

  if (!response.ok) {
    throw await response.json();
  }

  const headerValues = getFastshotHeaderValues({
    headers: response.headers,
  });

  return {
    ...headerValues,
    image: URL.createObjectURL(await response.blob()),
  };
};
